import styled from '@emotion/styled'

export const StyleHowItWorkWrapper = styled.div`
  width: full;
  height: auto;
  background-color: #f1fafb;

  margin-top: 60px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`
export const StyleHowItWorkBottomWrapper = styled.div`
  display: grid;
  width: full;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 30px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }
  margin-top: 30px;
`
export const StyleHowItWorkBottomContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  align-items: self-start;
  justify-content: flex-start;
  flex: 1;
  @media (max-width: 768px) {
    row-gap: 5px;
    margin-bottom: 10px;
  }
`
